// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"c7d7dc54","605":"18779543","809":"62452d41","981":"6c5dbd70"}[chunkId] + ".chunk.js";
};